import { TAGS } from '../../../../../shared/constants/analyticsConstants/generativeCallReview';

interface SchedulingEngagement {
    sessionTags?: string[];
    isContainable?: boolean;
    isContained?: boolean;
}

export const APPOINTMENT_SUCCESS_TAGS: string[] = [
    TAGS.ACTION_COMPLETED,
    TAGS.APPOINTMENT_RESCHEDULED,
    TAGS.APPOINTMENT_CANCELLED,
    TAGS.CHECK_NEXT_APPOINTMENT_COMPLETE,
    TAGS.INBOUND_APPOINTMENT_CONFIRMED,
    TAGS.OUTBOUND_APPOINTMENT_CONFIRMED
];

export const countAppointmentEvents = (engagements: SchedulingEngagement[], tags: string[] = APPOINTMENT_SUCCESS_TAGS): number =>
    engagements.reduce((total, engagement) => total + (engagement.sessionTags || []).filter(tag => tags.includes(tag)).length, 0);

export const isSchedulingContainable = (engagement: SchedulingEngagement): boolean =>
    !(engagement.sessionTags || []).includes(TAGS.OUTBOUND_CALL) &&
    !!(engagement.isContainable || (engagement.sessionTags || []).includes(TAGS.INBOUND_APPOINTMENT_CONFIRMED));

export const isSchedulingContained = (engagement: SchedulingEngagement): boolean =>
    !(engagement.sessionTags || []).includes(TAGS.OUTBOUND_CALL) &&
    !!(engagement.isContained || (engagement.sessionTags || []).includes(TAGS.INBOUND_APPOINTMENT_CONFIRMED));

interface OutboundAppointmentCounts {
    scheduled: number;
    rescheduled: number;
    cancelled: number;
    confirmed: number;
    leftMessage: number;
}

export const buildAppointmentChartData = (
    events: { type: string; count: number }[],
    outbound?: OutboundAppointmentCounts
): { category: string; Inbound: number; Outbound: number }[] => {
    const categories = ['Schedule', 'Reschedule', 'Cancel', 'Check', 'Confirm'];
    const outboundCounts = outbound ? {
        Schedule: outbound.scheduled,
        Reschedule: outbound.rescheduled,
        Cancel: outbound.cancelled,
        Confirm: outbound.confirmed
    } : {};
    const rows = categories.map(category => ({
        category,
        Inbound: events.find(event => event.type === category)?.count || 0,
        Outbound: outboundCounts[category] || 0
    }));
    if (outbound) {
        rows.push({ category: 'Voicemail', Inbound: 0, Outbound: outbound.leftMessage });
    }
    return rows;
};

export const getAppointmentsManagedTotal = (events: { count: number }[], outboundConfirmed: number): number =>
    events.reduce((sum, event) => sum + event.count, 0) + outboundConfirmed;

export const deduplicateAppointmentRecords = <T extends { id?: string; sessionId?: string; applicationId?: string }>(records: T[]): T[] => {
    const seen = new Set<string>();
    return records.filter(record => {
        const identity = record.sessionId || record.id;
        if (!identity) return true;
        const key = `${record.applicationId || ''}::${identity}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
};
